import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  InputAdornment,
  Typography,
  Grid,
  capitalize,
} from "@mui/material";
import { formatNumberWithCommas, parseCampos } from "../../../../utils/generalFunctions";
import MetodoDePagoDialog from "../../centro_cobros/components/metododepagodialog";

const CobrarInicialDialog = ({ moneda, open, onClose, onConfirm, productoSelected, camposInventario }) => {
  const [monto, setMonto] = useState("");
  const [montoText, setMontoText] = useState("");
  const [openMetodoDePago, setOpenMetodoDePago] = useState(false);

  const handleConfirmMetodoDePago = (paymentData) => {
    if (!monto || parseFloat(monto) <= 0) return; // Validación simple
    onConfirm(parseFloat(monto));
    setMonto("");

    onConfirm(monto,montoText,paymentData)

  };

  const handleConfirm = () => {
    if (!monto || parseFloat(monto) <= 0) return; // Validación simple
    onConfirm(parseFloat(monto));
    setMonto("");

    onConfirm(monto,montoText)
  };

  const handleClose = () => {
    setMonto("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle>Cobrar Inicial</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} mb={2}>
            {productoSelected && camposInventario.map((campo,index) => {
                var value = parseCampos(productoSelected["campos"])[campo.id];
                
                return(
                <>
                <Grid item size={4} key={campo.id}>
                <Typography fontWeight={600} textAlign={"left"} mx={1}>{campo.id=="id"?capitalize(campo.alias):capitalize(campo.name)}</Typography>
                <TextField
                slotProps={{
                    input: {
                    startAdornment:campo.type === 'monto' ? (
                        <InputAdornment position="start">{moneda.label}$</InputAdornment>
                    ) : null,
                    },
                }}
                    fullWidth
                    value={campo.type=="monto"?formatNumberWithCommas(value?.toString()): value}
                    disabled={true}
                    />
                </Grid>
                </>
                )
            })
            }

        </Grid>
        <Typography variant="body2" mb={2}>
          Ingrese el monto del inicial que desea cobrar:
        </Typography>
        <TextField
          fullWidth
          placeholder="Monto del inicial"
          value={montoText}
          onChange={(e) => {setMonto(e.target.value.replace(/[^0-9.]/g, '')); setMontoText(formatNumberWithCommas(e.target.value))}}
          InputProps={{
            startAdornment: <InputAdornment position="start">RD$</InputAdornment>,
          }}
        />
      </DialogContent>
      
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button
          sx={{ fontWeight: "bold" }}
          onClick={() => setOpenMetodoDePago(true)}
          color="primarybutton"
          variant="contained"
          disabled={!monto || parseFloat(monto) <= 0}
        >
          Confirmar
        </Button>
      </DialogActions>
      <MetodoDePagoDialog
            open={openMetodoDePago}
            onClose={() => setOpenMetodoDePago(false)}
            onConfirm={handleConfirmMetodoDePago}
            amount={parseFloat(monto.replace(/,/g, "") || 0)}
            title="Pago de Inicial"
            description="Seleccione el método de pago para el inicial"
            showAmount={true}
            defaultMethod="efectivo"
          />

    </Dialog>
  );
};

export default CobrarInicialDialog;
